export default __webpack_public_path__ + "images/referenzen/imagefilm/collins_about_me.mp4";